import * as types from "./action_types";

export function setSelectedVendorTraceFilters (vendorTraceFilters) {
    return {
        type: types.SET_SELECTED_VENDOR_TRACE_FILTERS,
        vendorTraceFilters,
    };
}

export function setSelectedVendorTracePrevalenceFilters (vendorTracePrevalenceFilter) {
    return {
        type: types.SET_SELECTED_VENDOR_TRACE_PREVALENCE_FILTER,
        vendorTracePrevalenceFilter,
    };
}

export function setIsCollapseChildren (isCollapseChildren) {
    return {
        type: types.SET_IS_COLLAPSE_CHILDREN,
        isCollapseChildren,
    };
}

export function setConsentTypeFilter (consentTypeFilter) {
    return {
        type: types.SET_CONSENT_TYPE_FILTER,
        consentTypeFilter,
    };
}
export function setMaxTraceLevel (maxTraceLevel) {
    return {
        type: types.SET_MAX_TRACE_LEVEL,
        maxTraceLevel,
    };
}

export function setSearchByVendorNameMode (searchByVendorNameMode) {
    return {
        type: types.SET_SEARCH_BY_VENDOR_NAME_MODE,
        searchByVendorNameMode,
    };
}

export function setPriorToConsentFilterList (priorToConsentFilterList) {
    return {
        type: types.SET_PRIOR_TO_CONSENT_FILTER_LIST,
        priorToConsentFilterList,
    };
}

export function resetVendorTrace () {
    return {
        type: types.RESET_VENDOR_TRACE,
    };
}
